import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const RejectPolicyDialog = ({
  open,
  onClose,
  onReject,
  policyName,
  isRejecting,
}) => {
  const [reason, setReason] = useState("");

  const handleReject = async () => {
    if (reason.trim()) {
      await onReject(reason);
      //   setReason("");
    } else {
      alert("Please provide a rejection reason.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
        setReason();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h5" fontWeight="bold">
          Reject Policy
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to reject{" "}
          <strong>{policyName || "this policy"}</strong>?
        </Typography>
        <TextField
          fullWidth
          margin="normal"
          label="Policy rejection reason"
          required
          multiline
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <LoadingButton
          onClick={handleReject}
          variant="contained"
          color="primary"
          disabled={!reason}
          loading={isRejecting}
        >
          Yes, Reject
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default RejectPolicyDialog;
